import React, { Fragment, useEffect, useState } from "react";
import { CCollapse, CLink } from "@coreui/react";
import DataTable from "react-data-table-component";
import { Formik, Form, Field } from "formik";
import Loader from "../Loader/Loader";
import axios from "axios";
import config from "../../config/config";
import { toastSuccess, toastError } from "../../common/Toast";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
  DELETE_MESSAGE,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  ALREADY_EXIST,
  AWS_IMAGE_FOLDER_ITEMS,
} from "../../common/Constant";

import DeleteConfirmationModalBanner from "../Modal/DeleteConfirmation";

function MainMenuBar({ visibleMainMenuChange, searchQuery, dynamicModule }) {
  const [visibleMainMenu, setVisibleMainMenu] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showMainMenu, setShowMainMenu] = useState(0);
  const [mainMenu, setMainMenu] = useState(visibleMainMenuChange);
  const token = localStorage.getItem("Token");
  //   const [topLeftContent, setTopLeftContent] = useState();
  // Form Values
  const [formValues, setFormValues] = useState({
    label1: "",
    value1: "",
    label2: "",
    value2: "",
    label3: "",
    value3: "",
    label4: "",
    value4: "",
    label5: "",
    value5: "",
    isActive: 0,
    sendTo: "MainMenu",
    from: dynamicModule,
  });

  console.log(formValues.isActive, "formValues123000000");

  async function getMainMenuDetails() {
    await axios
      .get(
        `${config.ecommconfigBaseUrl}/ecomconfig/commonconfigvalues?configtype=MainMenu&from=${dynamicModule}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        const resData = res.data.ResponseData;
        setFormValues({
          ...formValues,
          label1: resData[0]?.Name,
          value1: resData[0]?.Url,
          label2: resData[1]?.Name,
          value2: resData[1]?.Url,
          label3: resData[2]?.Name,
          value3: resData[2]?.Url,
          label4: resData[3]?.Name,
          value4: resData[3]?.Url,
          label5: resData[4]?.Name,
          value5: resData[4]?.Url,
          isActive: Number(resData[0]?.MainMenuIsActive),
        });
      })
      .catch((err) => {});
  }

  useEffect(() => {
    getMainMenuDetails();
  }, [dynamicModule]);

  const handleSubmit = (event) => {
    event.preventDefault();

    setLoading(true);

    // Ensure dynamicModule is included in formValues
    const payload = {
      ...formValues,
      from: dynamicModule, // overwrite or ensure latest value
    };

    axios
      .post(`${config.ecommconfigBaseUrl}/ecomconfig/mainmenuupsert`, payload, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          // toastError("Email" + ALREADY_EXIST);
        } else {
          toastError(ERROR_MESSAGE);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    if (name === "isActive") {
      setFormValues({ ...formValues, [name]: event.target.checked ? 1 : 0 });
    } else {
      setFormValues({ ...formValues, [name]: value });
    }
  };

  const data = [
    {
      name: "Label 1",
      input: (
        <>
          <input
            className="form-control form-control-sm"
            placeholder="Insert Label.."
            name="label1"
            onChange={handleChange}
            value={formValues.label1}
            style={{ margin: "10px" }}
          />
          <input
            className="form-control"
            placeholder="URL..."
            name="value1"
            onChange={handleChange}
            value={formValues.value1}
            style={{ margin: "10px" }}
          />
        </>
      ),
    },
    {
      name: "Label 2",
      input: (
        <>
          <input
            className="form-control form-control-sm col-6"
            placeholder="Insert Label.."
            name="label2"
            onChange={handleChange}
            value={formValues.label2}
            style={{ margin: "10px" }}
          />
          <input
            className="form-control col-6"
            placeholder="URL..."
            name="value2"
            onChange={handleChange}
            value={formValues.value2}
            style={{ margin: "10px" }}
          />
        </>
      ),
    },
    {
      name: "Label 3",
      input: (
        <>
          <input
            className="form-control form-control-sm col-6"
            placeholder="Insert Label.."
            name="label3"
            onChange={handleChange}
            value={formValues.label3}
            style={{ margin: "10px" }}
          />
          <input
            className="form-control col-6"
            placeholder="URL..."
            name="value3"
            onChange={handleChange}
            value={formValues.value3}
            style={{ margin: "10px" }}
          />
        </>
      ),
    },
    {
      name: "Label 4",
      input: (
        <>
          <input
            className="form-control form-control-sm col-6"
            placeholder="Insert Label.."
            name="label4"
            onChange={handleChange}
            value={formValues.label4}
            style={{ margin: "10px" }}
          />
          <input
            className="form-control col-6"
            placeholder="URL..."
            name="value4"
            onChange={handleChange}
            value={formValues.value4}
            style={{ margin: "10px" }}
          />
        </>
      ),
    },
    {
      name: "Label 5",
      input: (
        <>
          <input
            className="form-control form-control-sm col-6"
            placeholder="Insert Label.."
            name="label5"
            onChange={handleChange}
            value={formValues.label5}
            style={{ margin: "10px" }}
          />
          <input
            className="form-control col-6"
            placeholder="URL..."
            name="value5"
            onChange={handleChange}
            value={formValues.value5}
            style={{ margin: "10px" }}
          />
        </>
      ),
    },
  ];

  const matchesSearchQuery = data.filter((el) => {
    return el.name.toLowerCase().includes(searchQuery.toLowerCase());
  });

  return (
    <Fragment>
      <Loader loading={loading} />

      <div className="card">
        <div className="card-header">
          <h5 className="card-title">
            <CLink
              className="link"
              onClick={() => {
                setVisibleMainMenu(!visibleMainMenu);
                setMainMenu(!!mainMenu);
              }}
            >
              Main Menu Bar
            </CLink>
          </h5>
        </div>
        <CCollapse visible={visibleMainMenu || visibleMainMenuChange}>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div
                className="p-4"
                style={{
                  // backgroundColor: "blanchedalmond",
                  border: "1px solid rgba(0,0,0,.12)",
                  borderRadius: "7px",
                }}
              >
                <div
                  className="d-flex align-items-center"
                  style={{ marginTop: "10px", marginleft: "20px" }}
                >
                  <label className="col-form-label p-lg-medium mr-2">
                    IsActive
                  </label>

                  <input
                    type="checkbox"
                    id="isActive"
                    name="isActive"
                    value="true"
                    onChange={handleChange}
                    checked={formValues?.isActive == 1}
                    style={{
                      height: "20px",
                      width: "20px",
                    }}
                  />
                </div>

                <div className="row mb-3 pt-3">
                  <div className="row">
                    <div
                      // className="col-md-2"
                      style={
                        {
                          // width: "100%",
                          // display: "grid",
                          // // gridTemplateColumns: "repeat(2,1fr)",
                          // gap: "10px",
                          // textAlign: "center",
                        }
                      }
                    >
                      {matchesSearchQuery &&
                        matchesSearchQuery?.map((el) => {
                          return (
                            <div
                              className="row align-items-center mb-3"
                              key={el.name}
                            >
                              <div className="col-md-2">
                                <label
                                  className="form-label"
                                  style={{ fontSize: "15px" }}
                                >
                                  {el.name}
                                </label>
                              </div>
                              <div className="col-md-5">
                                <input
                                  className="form-control"
                                  placeholder="Insert Label.."
                                  name={`label${el.name.split(" ")[1]}`} // like label1, label2
                                  onChange={handleChange}
                                  value={
                                    formValues[`label${el.name.split(" ")[1]}`]
                                  }
                                />
                              </div>
                              <div className="col-md-5">
                                <input
                                  className="form-control"
                                  placeholder="URL..."
                                  name={`value${el.name.split(" ")[1]}`} // like value1, value2
                                  onChange={handleChange}
                                  value={
                                    formValues[`value${el.name.split(" ")[1]}`]
                                  }
                                />
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
                <div
                  className="d-flex justify-content-center"
                  style={{ marginTop: "65px" }}
                >
                  <button type="submit" className="btn btn-sm btn-primary mb-3">
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </CCollapse>
      </div>
    </Fragment>
  );
}

export default MainMenuBar;
